import { render, staticRenderFns } from "./footer-family-sites.vue?vue&type=template&id=43707522&"
import script from "./footer-family-sites.vue?vue&type=script&lang=js&"
export * from "./footer-family-sites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports